

import Layout from "./components/layout/Layout";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

import AVLabGame from "./components/pages/AVLabGame";


function App() {
    return (
        <Layout>
            
            <AuthenticatedTemplate>
                <AVLabGame />
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <p>Please login...</p>
            </UnauthenticatedTemplate>
            
        </Layout>
    );
}

export default App;
